import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["title", "open", "handleClose", "hideX", "children", "closeIcon"];
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
var useStyles = makeStyles(function (theme) {
  return {
    dialogTitle: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1.5),
      top: theme.spacing(1.5),
      color: theme.palette.grey[500]
    }
  };
});

/**
 * Defines a common dialog component with an 'x' in top right corner which allows to close it.
 *
 * @param title Header text to the left of the 'x' button
 * @param open Whether the dialog is open
 * @param handleClose Close the dialog. This should set the open property to false.
 * @param children Dialog contents which usually consists of <DialogContent and <DialogActions> components.
 */
var CloseableDialog = function CloseableDialog(_ref) {
  var title = _ref.title,
    open = _ref.open,
    handleClose = _ref.handleClose,
    hideX = _ref.hideX,
    children = _ref.children,
    closeIcon = _ref.closeIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, Object.assign({
    open: Boolean(open),
    maxWidth: "sm",
    "aria-labelledby": "dialog",
    disableScrollLock: true
  }, props), /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true,
    className: classes.dialogTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, title), !hideX && handleClose && /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: handleClose
  }, closeIcon ? closeIcon : /*#__PURE__*/React.createElement(CloseIcon, null))), children);
};
export default CloseableDialog;